/* eslint-disable no-extra-boolean-cast */
/* eslint-disable camelcase */
/* eslint-disable jsx-quotes */
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import Fuse from 'fuse.js';
import moment from 'moment';

import routes from '../../utils/routes';
import { formattedDate } from '../../utils/date-utils';
import { createClass, deleteClass, fetchClasses } from './classes.actions';
import {
    fetchTypesTests,
    asyncFetchCourseTemplateTests,
} from '../courses/courses.actions';
import { fetchUserDataByClass } from '../users/users.actions';
import DataTable from '../data-table/data-table';
import Modal from '../modal/modal';
import Loader from '../loader-component/loader';
import ConfirmationModal from '../confirmation-modal/confirmation-modal';
import SelectTest from '../SelectTest';

import './classes.css';

class Classes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showAddModal: false,
            showFilters: false,
            classId: '',
            className: '',
            courseName: '',
            center: '',
            endDate: '',
            startDate: '',
            trainer: '',
            page: 0,
            pageSize: 20,
            search: '',
        };
        this.clearState = this.clearState.bind(this);
        this.returnFilterModal = this.returnFilterModal.bind(this);
        this.onChangePageSize = this.onChangePageSize.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.onChangeSearch = this.onChangeSearch.bind(this);
    }

    componentDidMount() {
        this.props.fetchClasses();
        this.props.fetchTypesTests();
    }

    clearState() {
        this.setState({
            classId: '',
            showFilters: false,
            courseName: '',
            className: '',
            center: '',
            endDate: '',
            startDate: '',
            trainer: '',
        });
    }

    returnFilterModal() {
        const {
            classId,
            className,
            courseName,
            center,
            endDate,
            startDate,
            trainer,
            showFilters,
        } = this.state;
        return (
            <Modal show={showFilters} onClose={this.clearState}>
                <div className="filter-modal">
                    <div className="modal-header">
                        <span>Filtros</span>
                        <i
                            className="fa fa-times"
                            onClick={this.clearState}
                            title="Fechar"
                        />
                    </div>
                    <div className="filter-input-group">
                        <label>Sigla</label>
                        <input
                            id="sigla"
                            value={classId}
                            onChange={({ target }) =>
                                this.setState({ classId: target.value })
                            }
                        />
                    </div>

                    <div className="filter-input-group">
                        <label>Nome</label>
                        <input
                            id="name"
                            value={className}
                            onChange={({ target }) =>
                                this.setState({ className: target.value })
                            }
                        />
                    </div>
                    <div className="filter-input-group">
                        <label>Curso</label>
                        <input
                            id="course"
                            value={courseName}
                            onChange={({ target }) =>
                                this.setState({ courseName: target.value })
                            }
                        />
                    </div>
                    <div className="filter-input-group">
                        <label>Inicio</label>
                        <input
                            id="start"
                            value={startDate}
                            onChange={({ target }) =>
                                this.setState({ startDate: target.value })
                            }
                        />
                    </div>
                    <div className="filter-input-group">
                        <label>Término</label>
                        <input
                            id="name"
                            value={endDate}
                            onChange={({ target }) =>
                                this.setState({ endDate: target.value })
                            }
                        />
                    </div>
                    <div className="filter-input-group">
                        <label>Trainer</label>
                        <input
                            id="name"
                            value={trainer}
                            onChange={({ target }) =>
                                this.setState({ trainer: target.value })
                            }
                        />
                    </div>
                    <div className="filter-input-group">
                        <label>Unidade</label>
                        <input
                            id="name"
                            value={center}
                            onChange={({ target }) =>
                                this.setState({ center: target.value })
                            }
                        />
                    </div>
                    <div className="modal-footer">
                        <button
                            className="cancel-btn"
                            onClick={this.clearState}
                        >
                            Limpar Filtros
                        </button>
                        <button
                            className="save-btn"
                            onClick={() =>
                                this.setState({ showFilters: false })
                            }
                        >
                            Ok
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }

    onChangePageSize(pageSize, page) {
        if (page !== this.state.page || pageSize !== this.state.pageSize) {
            this.setState({
                page,
                pageSize,
            });
        }
    }

    onChangePage(page) {
        if (page !== this.state.page) {
            this.setState({
                page,
            });
        }
    }

    onChangeSearch(search) {
        if (search !== this.state.search) {
            this.setState({
                search,
                page: 0,
            });
        }
    }
    render() {
        const {
            courses,
            trainers,
            centers,
            loading,
            typeTests,
            tests,
            asyncFetchCourseTemplateTests,
            course_template_tests,
        } = this.props;
        const {
            classId,
            className,
            courseName,
            center,
            endDate,
            startDate,
            trainer,
            showFilters,
            page,
            pageSize,
        } = this.state;
        const data = this.makeClassesData();
        return (
            <div className="classes-list-container classes">
                <Loader
                    show={loading ? true : false}
                    message={'Carregando, por favor aguarde...'}
                />
                <div className="new-entity-btn">
                    <button
                        className="add-class-btn"
                        onClick={() => this.setState({ showAddModal: true })}
                        title="Nova Turma"
                    >
                        <i className="fa fa-plus" />
                    </button>
                </div>
                <DataTable
                    className="classes-table"
                    data={data.slice(page * pageSize, (pageSize * page) + pageSize)}
                    allData={data}
                    columns={this.COLUMNS}
                    exportName={`turmas-${moment().toISOString()}.csv`}
                    filtered={[
                        { id: 'classId', value: classId },
                        { id: 'courseName', value: courseName },
                        { id: 'className', value: className },
                        { id: 'center', value: center },
                        { id: 'endDate', value: endDate },
                        { id: 'startDate', value: startDate },
                        { id: 'trainer', value: trainer },
                    ]}
                    fetchMethod={this.makeClassesData}
                    fetchAllMethod={this.makeClassesData}
                    pages={Math.ceil(data.length / pageSize)}
                    page={page}
                    pageSize={pageSize}
                    manual
                    onPageChange={this.onChangePage}
                    onPageSizeChange={this.onChangePageSize}
                    onChangeSearch={this.onChangeSearch}
                    searchFunction={() =>
                        this.setState({ showFilters: !showFilters })
                    }
                />
                {this.returnFilterModal()}
                {this.state.showAddModal && (
                    <NewClassModal
                        onClose={() => this.setState({ showAddModal: false })}
                        onSave={({
                            classId,
                            className,
                            courseId,
                            trainerId,
                            centerId,
                            typeTestsValues,
                        }) =>
                            this.props.createClass(
                                classId,
                                className,
                                courseId,
                                trainerId,
                                centerId,
                                typeTestsValues,
                            )
                        }
                        courses={courses}
                        trainers={trainers}
                        centers={centers}
                        typeTests={typeTests}
                        tests={tests}
                        asyncFetchCourseTemplateTests={asyncFetchCourseTemplateTests.bind(
                            this,
                        )}
                        courseTemplateTests={course_template_tests}
                    />
                )}
            </div>
        );
    }

    trainerById = trainerId => {
        return this.props.trainers.find(t => t.userId === trainerId) || {};
    };

    centerById = centerId => {
        return this.props.centers.find(c => c.id === centerId) || {};
    };

    makeClassesData = () => {
        const classes = this.props.classes.map(c => ({
            ...c,
            trainer: this.trainerById(c.trainerId).obsoleteName || '',
            center: this.centerById(c.centerId).name || '',
            expired: isExpired(c),
        }));

        if (!this.state.search) {
            return classes;
        } else {
            return this.filteredData(classes, this.state.search, this.COLUMNS);
        }
    }

    filteredData = (data, search, columns) => {
        const key = search;
        const keys = columns
            .filter(c => c.searchable)
            .map(m => m.accessor);
        if (!key.trim() || keys.length === 0) {
            return data;
        }
        return new Fuse(data, {
            threshold: 0.0,
            minMatchCharLength: 0,
            keys,
        }).search(key);
    };

    selectFilter = (options, accessor) => ({ filter, onChange }) => {
        const sortedOption = this.props[options].sort((a, b) =>
            a[accessor] < b[accessor] ? -1 : a[accessor] > b[accessor] ? 1 : 0,
        );

        return (
            <select
                onChange={event => onChange(event.target.value)}
                style={{ width: '100%' }}
                value={filter ? filter.value : ''}
            >
                <option value="">Todos</option>
                {sortedOption.map((opt, i) => (
                    <option key={i} value={opt[accessor]}>
                        {opt[accessor]}
                    </option>
                ))}
            </select>
        );
    };

    COLUMNS = [
        {
            Header: 'Sigla',
            searchable: true,
            accessor: 'classId',
            Cell: row => (
                <span
                    className={row.original.expired ? 'expired' : ''}
                    title={row.value}
                >
                    {row.value}
                </span>
            ),
        },
        {
            Header: 'Nome',
            searchable: true,
            accessor: 'className',
            Cell: row => (
                <span
                    className={row.original.expired ? 'expired' : ''}
                    title={row.value}
                >
                    {row.value}
                </span>
            ),
        },
        {
            Header: 'Curso',
            searchable: true,
            accessor: 'courseId',
            Cell: row => {
                const currentCourses = this.props.courses.find(e=>e.courseId === row.value);
                return (
                    <span
                        className={row.original.expired ? 'expired' : ''}
                        title={row.value}
                    >
                        {currentCourses ? currentCourses.courseName : ''}
                    </span>
                );
            },
        },
        {
            Header: 'Início',
            accessor: 'startDate',
            Cell: row => (
                <span
                    className={row.original.expired ? 'expired' : ''}
                    title={formattedDate(row.value)}
                >
                    {formattedDate(row.value)}
                </span>
            ),
        },
        {
            Header: 'Término',
            accessor: 'endDate',
            Cell: row => (
                <span
                    className={row.original.expired ? 'expired' : ''}
                    title={formattedDate(row.value)}
                >
                    {formattedDate(row.value)}
                </span>
            ),
        },
        {
            Header: 'Trainer',
            searchable: true,
            accessor: 'trainer',
            Cell: row => (
                <span
                    className={row.original.expired ? 'expired' : ''}
                    title={row.value}
                >
                    {row.value}
                </span>
            ),
        },
        {
            Header: 'Unidade',
            searchable: true,
            accessor: 'center',
            Cell: row => (
                <span
                    className={row.original.expired ? 'expired' : ''}
                    title={row.value}
                >
                    {row.value}
                </span>
            ),
        },
        {
            Header: 'Ações',
            filterable: false,
            exportable: false,
            Cell: props => <ActionsCell {...props} />,
            sortable: false,
        },
    ];
}

const mapStateToProps = ({ classes, courses, trainers, centers, users }) => ({
    classes: classes.data,
    loading:
        classes.loading || courses.loading || trainers.loading || users.loading,
    courses: courses.data,
    trainers: trainers.data,
    centers: centers,
    typeTests: courses.typeTests,
    tests: courses.tests,
    course_template_tests: courses.course_template_tests,
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            createClass,
            fetchClasses,
            fetchTypesTests,
            asyncFetchCourseTemplateTests,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(Classes);

class NewClassModal extends React.Component {
    state = {
        classId: '',
        className: '',
        courseId: '',
        trainerId: '',
        centerId: '',
        tests: null,
        typeTests: [],
        typeTestsValues: {},
    };

    componentDidMount() {
        const { tests, typeTests } = this.props;

        const toSetTypeTestsValues = this.setTypeTestsToValues(typeTests);

        this.setState({
            tests,
            typeTests,
            typeTestsValues: toSetTypeTestsValues,
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            typeTests,
            tests,
            courseTemplateTests,
            asyncFetchCourseTemplateTests,
        } = this.props;
        const { courseId } = this.state;

        if (typeTests !== prevProps.typeTests) {
            const toSetTypeTestsValues = this.setTypeTestsToValues(typeTests);

            this.setState({
                typeTests,
                typeTestsValues: toSetTypeTestsValues,
            });
        }

        if (tests !== prevProps.tests) {
            this.setState({
                tests,
            });
        }

        if (courseTemplateTests !== prevProps.courseTemplateTests) {
            this.setState({
                typeTestsValues: courseTemplateTests,
            });
        }

        if (courseId !== prevState.courseId) {
            asyncFetchCourseTemplateTests({
                courseId,
            });
        }
    }

    setTypeTestsToValues(typeTests) {
        const { typeTestsValues } = this.state;
        const auxToSetTypeTestsValues = {};
        typeTests.map(typeTest => {
            Object.assign(auxToSetTypeTestsValues, {
                [typeTest.id]: typeTestsValues[typeTest.id] || null,
            });
        });
        const toSetTypeTestsValues = auxToSetTypeTestsValues;

        return toSetTypeTestsValues;
    }

    handleChangeSelectTest(valueSelect, testId) {
        const { typeTestsValues } = this.state;
        const auxValuesTest = typeTestsValues;

        this.setState({
            // eslint-disable-next-line comma-dangle
            typeTestsValues: {
                ...auxValuesTest,
                [testId]: !!valueSelect ? valueSelect : null,
            },
        });
    }

    handleChange = ({ target }) => {
        const value =
            target.name === 'classId'
                ? target.value.replace(/[^\w-]*/g, '')
                : target.value;
        this.setState({ [target.name]: value });
    };

    handleSubmit = e => {
        e.preventDefault();
        this.props.onSave(this.state);
        this.props.onClose();
    };

    handleCancel = e => {
        e.preventDefault();
        this.props.onClose();
    };

    render() {
        const {
            classId,
            className,
            courseId,
            trainerId,
            centerId,
            typeTests,
            tests,
            typeTestsValues,
        } = this.state;
        const {
            courses = [],
            trainers = [],
            centers = [],
            ...props
        } = this.props;
        return (
            <Modal show={true} {...props}>
                <div className="new-class-modal">
                    <h4>Nova turma</h4>
                    <form onSubmit={this.handleSubmit}>
                        <div className="new-class-modal-fields">
                            <div className="inline-form-row">
                                <label>Sigla:</label>
                                <input
                                    name="classId"
                                    value={classId}
                                    onChange={this.handleChange}
                                />
                            </div>
                            <div className="inline-form-row">
                                <label>Nome:</label>
                                <input
                                    name="className"
                                    value={className}
                                    onChange={this.handleChange}
                                />
                            </div>
                            <div className="inline-form-row">
                                <label>Curso:</label>
                                <select
                                    name="courseId"
                                    value={courseId}
                                    onChange={this.handleChange}
                                >
                                    <option key="" value="">
                                        Selecione um curso
                                    </option>
                                    {courses
                                        .sort((a, b) => {
                                            if (
                                                String(
                                                    a.courseName,
                                                ).toLowerCase() <
                                                String(
                                                    b.courseName,
                                                ).toLowerCase()
                                            ) {
                                                return -1;
                                            }
                                            if (
                                                String(
                                                    a.courseName,
                                                ).toLowerCase() >
                                                String(
                                                    b.courseName,
                                                ).toLowerCase()
                                            ) {
                                                return 1;
                                            }
                                            return 0;
                                        })
                                        .map(course => (
                                            <option
                                                key={course.courseId}
                                                value={course.courseId}
                                            >
                                                {course.courseName}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            {typeTests &&
                                typeTests.map((typeTest, index) => (
                                    <SelectTest
                                        key={index}
                                        name={typeTest.label}
                                        typeTest={typeTest}
                                        tests={tests}
                                        onChange={this.handleChangeSelectTest.bind(
                                            this,
                                        )}
                                        value={
                                            typeTestsValues[typeTest.id] || ''
                                        }
                                    />
                                ))}
                            <div className="inline-form-row">
                                <label>Trainer:</label>
                                <select
                                    name="trainerId"
                                    value={trainerId}
                                    onChange={this.handleChange}
                                >
                                    <option value="">
                                        Selecione um trainer
                                    </option>
                                    {trainers
                                        .sort((a, b) => {
                                            if (
                                                String(
                                                    a.obsoleteName,
                                                ).toLowerCase() <
                                                String(
                                                    b.obsoleteName,
                                                ).toLowerCase()
                                            ) {
                                                return -1;
                                            }
                                            if (
                                                String(
                                                    a.obsoleteName,
                                                ).toLowerCase() >
                                                String(
                                                    b.obsoleteName,
                                                ).toLowerCase()
                                            ) {
                                                return 1;
                                            }
                                            return 0;
                                        })
                                        .map(t => (
                                            <option
                                                key={t.userId}
                                                value={t.userId}
                                            >
                                                {t.obsoleteName}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            <div className="inline-form-row">
                                <label>Unidade:</label>
                                <select
                                    name="centerId"
                                    value={centerId}
                                    onChange={this.handleChange}
                                >
                                    <option value="">
                                        Selecione uma unidade
                                    </option>
                                    {centers
                                        .sort((a, b) => {
                                            if (
                                                String(a.name).toLowerCase() <
                                                String(b.name).toLowerCase()
                                            ) {
                                                return -1;
                                            }
                                            if (
                                                String(a.name).toLowerCase() >
                                                String(b.name).toLowerCase()
                                            ) {
                                                return 1;
                                            }
                                            return 0;
                                        })
                                        .map(c => (
                                            <option key={c.id} value={c.id}>
                                                {c.name}
                                            </option>
                                        ))}
                                </select>
                            </div>
                        </div>
                        <div className="new-class-modal-btns">
                            <button onClick={this.handleCancel}>
                                Cancelar
                            </button>
                            <button
                                type="submit"
                                disabled={
                                    !classId ||
                                    !className ||
                                    !courseId ||
                                    !trainerId ||
                                    !centerId
                                }
                            >
                                Adicionar
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>
        );
    }
}

class ActionsGroup extends React.Component {
    state = {
        askConfirmation: false,
        showEnrollmentModal: false,
    };

    handleEnrollmentsClick = () => {
        this.props.fetchUserDataByClass(this.props.original.classId);
        this.setState({ showEnrollmentModal: true });
    };

    render() {
        const { row } = this.props;
        return (
            <div className="actions-row">
                <Link to={routes.CLASS_RESOURCES(row.classId)}>
                    <button title="Editar">
                        <i className="fa fa-edit" />
                    </button>
                </Link>
                <button
                    title="Remover"
                    onClick={() => this.setState({ askConfirmation: true })}
                >
                    {' '}
                    <i className="fa fa-trash" />
                </button>
                <button
                    title="Matrículas"
                    onClick={this.handleEnrollmentsClick}
                >
                    <i className="fa fa-address-book-o" />
                </button>
                {this.state.askConfirmation && (
                    <ConfirmationModal
                        show={true}
                        onClose={() =>
                            this.setState({ askConfirmation: false })
                        }
                        onConfirm={() => this.props.deleteClass(row.classId)}
                    />
                )}
                {this.state.showEnrollmentModal && (
                    <EnrollmentModal
                        currentClassId={this.props.original.classId}
                        onClose={() =>
                            this.setState({ showEnrollmentModal: false })
                        }
                        coaches={this.props.coaches}
                        loading={this.props.loading}
                    />
                )}
            </div>
        );
    }
}

class EnrollmentModal extends React.Component {
    render() {
        const { loading } = this.props;
        const coaches = this.props.coaches.filter(c => c && c.name && c.email);
        return (
            <Modal
                show={true}
                {...this.props}
                overlayStyle={{ opacity: loading ? 0 : 1 }}
            >
                <div className="students-modal">
                    {loading && <div style={{ display: 'none' }} />}
                    {!loading && (
                        <React.Fragment>
                            <div className="modal-header">
                                <span>
                                    Alunos matriculados em{' '}
                                    {this.props.currentClassId}
                                </span>
                                <i
                                    className="fa fa-times"
                                    onClick={this.props.onClose}
                                    title="Fechar"
                                />
                            </div>
                            {coaches.length === 0 && (
                                <div className="empty-list">
                                    Nenhum aluno matriculado!
                                </div>
                            )}
                            {coaches.length > 0 && (
                                <table className="classes-registers">
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                            <th>E-mail</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {coaches.map((coach, i) => (
                                            <tr key={i}>
                                                <td>{coach.name}</td>
                                                <td>{coach.email}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </React.Fragment>
                    )}
                </div>
            </Modal>
        );
    }

    COLUMNS = [
        { Header: 'Nome', accessor: 'name' },
        { Header: 'Email', accessor: 'email' },
    ];
}

const ActionsCell = connect(
    ({ users, courses }) => ({
        coaches: users.coaches,
        loading: users.loading,
        courses: courses.data,
    }),
    dispatch =>
        bindActionCreators(
            {
                deleteClass,
                fetchUserDataByClass,
            },
            dispatch,
        ),
)(ActionsGroup);

function isExpired(aClass) {
    return aClass.endDate && moment(moment()).isAfter(aClass.endDate);
}



// WEBPACK FOOTER //
// ./src/components/classes/classes.js